import { roomSchema } from "@ssf/play-common";
import { roomsRef, useValue } from "@ssf/play-components";
import type { DataSnapshot } from "firebase/database";

const onSuccess = (data: DataSnapshot) => {
  const res = roomSchema.safeParse(data.val());
  if (res.success) {
    return res.data;
  }
  return undefined;
};

export const useRoom = (roomKey?: string) =>
  useValue(roomsRef, roomKey!)({ disabled: !roomKey, onSuccess });
